@if (showGauge) {
  <div class="PR gauge-container card-border">
    <div class="car-meter-gauge-title">{{ carGaugeOptions.name }}</div>
    <div echarts [options]="options" class="car-meter-gauge"></div>
  </div>
}

